module.exports = __webpack_public_path__ + "static/media/bicycle-outline.93172094.svg";